import { Autocomplete, CircularProgress,  MenuItem } from "@mui/material"
import {  memo } from "react"
import {  useSelector } from 'react-redux'
import CustomInput from "../../components/inputs/CustomInput"
import { REGIONS_TYPE } from "../../utils/constants"
import {  findObjectKeyByValue, titleCase } from "../../utils/helper"
import AsyncDropDown from "../../components/inputs/AsyncDropDown"
import CustomDialog from "../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../components/layouts/OneViewBox"




const CreateUi = ({ title, modalKey, isUpdate, fields, setFields, loading, onSubmit }) => {
    const { user } = useSelector(state => state)


    return <>

        <CustomDialog
            id={modalKey}
            loading={loading}
            err={fields.err}
            onSubmit={onSubmit}
            title={`${isUpdate ? "Update" : "Create"} ${title}`}
            closeText="Close"
            confirmText={`${isUpdate ? "Update" : "Create"}`}
        >

            {loading ? <CenteredBox><CircularProgress /></CenteredBox> :
                <>
                    {<CustomInput
                        autoFocus={true}
                        disabled={loading}
                        value={fields.title}
                        onChange={(e) => setFields({ ...fields, err: '', title: e.target.value })}
                        type="text"
                        label={"Topic*"}

                    />}



                    {/* {!isUpdate && <Autocomplete

                        disableClearable

                        value={fields.type ? findObjectKeyByValue(fields.type, REGIONS_TYPE) : null}

                        onChange={(e, newVal) => {
                            setFields({ ...fields, type: newVal ? newVal._id : null, parent: null })
                        }}
                        options={[...Object.keys(REGIONS_TYPE).map((key) => ({ label: titleCase(key), _id: REGIONS_TYPE[key] }))]}
                        sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
                        renderInput={(params) => <CustomInput placeholder="Select Region Type*" {...params} label="Select Region Type*" />}
                    />} */}

                    {/* {fields.type != REGIONS_TYPE.COUNTRY && <AsyncDropDown
                        disablePortal
                        key={fields.type}
                        id={"Select " + findObjectKeyByValue(fields.type - 1, REGIONS_TYPE).toLowerCase()}
                        name={"Select " + findObjectKeyByValue(fields.type - 1, REGIONS_TYPE).toLowerCase()}
                        lazyFun={async (para) => { return await getRegionApi({ ...para, type: fields.type - 1 }) }}
                        label={"Select " + findObjectKeyByValue(fields.type - 1, REGIONS_TYPE).toLowerCase()}
                        OptionComponent={({ option, ...rest }) => {
                            return <MenuItem {...rest}>{option.name}</MenuItem>
                        }}
                        onChange={async (changedVal) => {
                            setFields({ ...fields, parent: changedVal ? changedVal._id : null, })
                        }}
                        titleKey={'name'}
                        valueKey={"_id"}
                    />} */}

                </>}

        </CustomDialog>
    </>
}
export default memo(CreateUi)